import ListingTypeBox from '@app/components/ListingTypeBox'
import { IBrokeragePipeline } from '@app/models/BrokeragePipeline'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import { Link } from 'react-router-dom'

export interface IBrokeragePipelineResultItemProps {
  item: IBrokeragePipeline
}

export class BrokeragePipelineResultItem extends React.PureComponent<
  IBrokeragePipelineResultItemProps
> {
  public render() {
    return (
      <Link
        to={`/brokerage/pipeline/${this.props.item.id}`}
        className='result-item'
      >
        <div className='align-self-center'>
          <ListingTypeBox
            className='mr-2'
            status={this.props.item.status}
            type={this.props.item.associatedListing.type}
          />
        </div>
        <div className='flex-grow-1'>
          <div className='font-weight-bold'>
            {this.props.item.name}, {this.props.item.associatedProperty.name}
          </div>
          <div className='small'>
            {formatAddressSingleLine(
              this.props.item.associatedProperty.address,
            )}
          </div>
        </div>
      </Link>
    )
  }
}
